import api from "./workspaceApi";
import { Workspace } from "../lib/cnb/api/public";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DomainContext } from "../domain";

export const useWorkspace = () => {
  const [workspaces, setWorkspaces] = useState<Workspace[]>([]);
  const { currentDomain } = useContext(DomainContext);

  useEffect(() => {
    const fetchWorkspaces = async () => {
      const ws = await api.getWorkspaces();
      setWorkspaces(ws);
    };
    fetchWorkspaces();
  }, []);

  // Find the workspace that contains the current domain
  const currentWorkspace = useMemo(() => {
    if (!currentDomain || workspaces.length === 0) return undefined;
    return workspaces.find((workspace) =>
      workspace.domains.some(
        (wsDomain) => wsDomain.domain.name === currentDomain.name,
      ),
    );
  }, [currentDomain, workspaces]);

  return useMemo(
    () => ({
      workspaces,
      currentWorkspace,
    }),
    [workspaces, currentWorkspace],
  );
};

export const WorkspaceContext = createContext<ReturnType<typeof useWorkspace>>(
  null as any,
);
